import { Link } from 'react-router-dom';
import { styled, Theme } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';

export const sxStyles = {
  titleWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  action: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    fontWeight: 600,
    color: coreThemeColors.primary.main,
    whiteSpace: 'nowrap',
  },
} as const;

export const StyledBannerWrap = styled(Link)(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '1rem',
  width: '100%',
  minHeight: '80px',
  marginTop: '1.5rem',
  padding: '1rem 1.5rem',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.common.black,
  boxShadow: `0px 8px 24px -4px ${theme.palette.divider}`,
  borderBottomRightRadius: '12px',
  borderTopRightRadius: '12px',
  borderLeft: `5px solid ${coreThemeColors.primary.main}`,
  transition: 'box-shadow 0.5s',
  textDecoration: 'none',

  [theme.breakpoints.down('sm')]: {
    padding: '1rem',
  },

  '&:hover': {
    boxShadow: `0px 8px 32px -4px ${theme.palette.divider}`,
  },
}));
